import axios from 'axios'
import querystring from 'querystring'
import config from '../config'

export default (name, endpoint) => {
  const uri = '/' + endpoint

  return {

    getResource (NewsHeaders) {
      let headers = {}
      let header3 = {}

      if (localStorage.usuarioadmin !== 'undefined' && localStorage.usuarioadmin !== undefined && localStorage.usuarioadmin !== '') {
        headers.Authorization = 'Bearer ' + JSON.parse(localStorage.usuarioadmin).token
      }

      if (NewsHeaders) {
        header3 = {...headers, ...NewsHeaders}
      } else {
        header3 = headers
      }

      return axios.create({
        headers: header3,
        baseURL: config.api[name]
      })
    },

    async index (data) {
      return this.getResource().get(uri + '?' + querystring.stringify(data)).then(({ data }) => data)
    },
    async get (id, data) {
      return this.getResource().get(uri + '/' + id + '?' + querystring.stringify(data)).then(({ data }) => data)
    },
    async show (id) {
      return this.getResource().get(uri + '/' + id).then(({ data }) => data)
    },

    async create (data, headers) {
      return this.getResource(headers).post(uri, data).then(({ data }) => data)
    },

    async update (id, data, headers) {
      if (id) {
        return this.getResource(headers).put(uri + '/' + id, data).then(({ data }) => data)
      } else {
        return this.getResource(headers).put(uri, data).then(({ data }) => data)
      }
    },

    async save ({ id, ...data }) {
      if (id) {
        return this.update(id, data)
      }
      return this.create(data)
    },

    async destroy (id) {
      return this.getResource().delete(uri + '/' + id).then(({ data }) => data)
    },

    async restore (id) {
      return this.getResource().put(uri + '/' + id).then(({ data }) => data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js